<template>
    <div class="menu-block">
        <div v-show="!showMenu" @click="showSidebar = !showSidebar" class="icon-theme mi-arrow-back mi-1-1x mr-1px transition-all-0-5" :class="{'rotate-180': !showSidebar}"></div>
        <div @click="showMenu = !showMenu" class="icon-theme icon-menu mi-1-1x" :class="{'mi-menu': !showMenu, 'mi-close': showMenu}"></div>
        <transition name="collapse">
            <div v-if="showMenu" class="mobile-menu" :style="{'background': menuColor}">

                <div v-if="!isMainDomain && !isGuest && Object.keys(currentUserAccount).length" class="group-items">
                    <BLink href="/projects" class="btn link-block" :class="classesLinkBlock(['projects'])" v-ripple>
                        <i class="mi-layers mr-1"></i><span>Projects</span>
                    </BLink>
                </div>

                <div v-if="!isMainDomain && (isCurrentAccountOwner || currentUserCan('manage_roles') || currentUserCan('manage_users'))" class="group-items">

                    <div class="text-block ml-1">
                        <i class="mi-people mr-1"></i><span>Team</span>
                    </div>

                    <BLink href="/users/active"
                           v-if="currentUserCan('manage_users')"
                           class="btn link-block"
                           :class="classesLinkBlock(['users/active'])"
                           v-ripple>
                        <span>Users</span>
                    </BLink>

                    <BLink href="/roles-and-permissions"
                           v-if="currentUserCan('manage_roles') || isCurrentAccountOwner"
                           class="btn link-block"
                           :class="classesLinkBlock(['roles-and-permissions'])"
                           v-ripple>
                        <span>Roles</span>
                    </BLink>

                    <BLink href="/account/teams"
                           v-if="currentUserCan('manage_users')"
                           class="btn link-block"
                           :class="classesLinkBlock(['account/teams'])"
                           v-ripple>
                        <span>Teams</span>
                    </BLink>
                </div>

                <div v-if="!isMainDomain && currentUserCan('view_editorial_calendar')" class="group-items">
                    <BLink href="/reports/calendar" class="btn link-block" :class="classesLinkBlock(['reports/calendar'])" v-ripple>
                        <i class="mi-date-range mr-1"></i><span>Calendar</span>
                    </BLink>
                </div>

                <div v-if="!isMainDomain && currentUserCan('manage_integrations')" class="group-items">
                    <BLink href="/integration" class="btn link-block" :class="classesLinkBlock(['integration'])" v-ripple>
                        <i class="mi-device-hub mr-1"></i><span>Integrations</span>
                    </BLink>
                </div>

                <div v-if="!isMainDomain && (currentUserCan('view_content_report') || currentUserCan('view_communication_report'))" class="group-items">

                    <div class="text-block ml-1">
                        <i class="mi-poll mr-1"></i><span>Reports</span>
                    </div>

                    <BLink href="/reports/content"
                           v-if="currentUserCan('view_content_report')"
                           class="btn link-block"
                           :class="classesLinkBlock(['reports/content'])"
                           v-ripple>
                        <span>Content report</span>
                    </BLink>

                    <BLink href="/reports/communication"
                           v-if="currentUserCan('view_communication_report')"
                           class="btn link-block"
                           :class="classesLinkBlock(['reports/communication'])"
                           v-ripple>
                        <span>Communication</span>
                    </BLink>

                </div>

                <div class="group-items">
                    <BLink :href="`/${helpPath}`" class="p-1 ml-1 mr-1 link-block" :class="{active: isActive([helpPath])}" v-ripple>
                        <i class="mi-help-outline top-0 mi-1-5x mr-1"></i><span>Help</span>
                    </BLink>
                </div>

                <div v-if="showDemo" class="group-items">
                    <BLink target="_blank" href="//calendly.com/easycontent/demo" class="btn btn-light btn-sm font-size-lg font-weight-500 schedule-demo ml-1 mr-1" v-ripple>
                        <span>schedule demo</span>
                    </BLink>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
import mixinNavbar from "@/mixins/navbar/mixin";
import {BLink} from "bootstrap-vue";
import {mapGetters, mapState} from "vuex";
import EventBus, {SIDEBAR_VISIBILITY} from "@/utils/event-bus";

export default {
    name: 'MenuBlock',
    components: {
        BLink
    },
    computed: {
        ...mapGetters(['currentUserCan', 'isCurrentAccountOwner']),
        ...mapState({
            isMainDomain: state => state.navbar.isMainDomain,
            isGuest: state => state.navbar.isGuest,
            currentUserAccount: state => state.navbar.currentUserAccount,
            menuColor: state => state.navbar.menuColor
        }),
    },
    watch: {
        showMenu(v) {
            this.$emit('show-menu', v);
        },
        outsideClick(v) {
            if (v) {
                this.showMenu = false;
            }
        },
        showSidebar: {
            handler(v) {
                EventBus.emit(SIDEBAR_VISIBILITY, v);
                window.dispatchEvent(new CustomEvent(SIDEBAR_VISIBILITY, {
                    detail: {
                        visibility: v
                    }
                }));
            },
            immediate: true
        },
    },
    props: {
        outsideClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showMenu: false,
            showSidebar: false
        }
    },
    mixins: [mixinNavbar]
}
</script>
